module.exports = __webpack_public_path__ + "img/iconRO.81000092.jpg";